<template>
  <div class="role-selector">
    <ue-select :options="roles" @input="selected" v-model="role" placeholder="Select Role" />
  </div>
</template>
<script lang="ts">
import { getRecipientRoles } from '@/survey/api.js'

export default {
  props: ['input', 'value'],
  data() {
    return {
      role: null,
      roles: [],
    }
  },
  mounted() {
    getRecipientRoles().then((roles) => {
      this.roles = roles
      this.role = this.roles.filter((role) => role.code == this.value)
    })
  },
  methods: {
    selected() {
      this.$emit('input', this.role.code)
    },
  },
}
</script>
<style lang="sass" scoped></style>
